
import axios from "axios";
import { defineComponent } from "vue";

export default defineComponent({
  data() {
    return {
      resetEmailSend: false,
      email: "",
      errorMsg: "",
      error: false,
    };
  },
  methods: {
    closeModal() {
      this.resetEmailSend = false;
      this.$emit("closeResetPasswordModal");
      this.error = false;
      this.errorMsg = "";
    },
    async sendInvite() {
      const response = await axios.post("/users/resetpassword", {
        email: this.email,
      });
      if (response.status === 400) {
        this.errorMsg = "L'adresse e-mail ne correspond à aucun utilisateur.";
        this.error = true;
        return;
      }
      if (response.status >= 300) {
        this.errorMsg = "Une erreur s'est produite.";
        this.error = true;
        return;
      }
      this.resetEmailSend = true;
    },
  },
});
